/* eslint-disable react/prop-types */
import React from 'react';

export default function FitPill({ fit }) {
  if (fit === 'EtaViolation') return <span className="fit-pill fit-eta">Randevu İhlali</span>;
  if (fit === 'Overtime') return <span className="fit-pill fit-overtime">Mesai Aşımı</span>;
  return <span className="fit-pill fit-fit">Uygun</span>;
}
